import * as React from 'react';
import { ICityResponse } from '../../interfaces/city';
import { INeighborhoodRespose } from '../../interfaces/neighborhood';
import { IStateResponse } from '../../interfaces/state';
import { IDrugResponse } from '../../interfaces/drug';
import ConfigService from '../../services/config-service';
import ePharmaServices from '../../services/epharma-services';
import keys from '../../util/keys';

export default function StoreHook()
{
    const [ states, setStates ] = React.useState<IStateResponse[]>();
    const [ loadingStates, setLoadingStates ] = React.useState(false);
    const [ cities, setCities ] = React.useState<ICityResponse[]>();
    const [ loadingCities, setLoadingCities ] = React.useState(false);
    const [ neighborhoods, setNeighborhoods ] = React.useState<INeighborhoodRespose[]>();
    const [ loadingNeighborhoods, setLoadingNeighborhoods ] = React.useState(false);

    
    const getState = async () =>
    {
        setLoadingStates(true);

        const baseUrl = await ConfigService().getConfig(keys.ePharmaCommonService);
        const stateUrl = await ConfigService().getConfig(keys.EndpointCommonState);

        const gridParams = {
            page: 1,
            itemsPerPage: 30,
            filter: [],
            sorter: [{PropertyName: "name", direction: "asc"}]
        };

        const response = await ePharmaServices(baseUrl).get(`${stateUrl}?gridParams=${JSON.stringify(gridParams)}`);

        setStates(response.data.data);

        setLoadingStates(false);
    }

    const getCities = async (stateId: number) =>
    {
        setLoadingCities(true);

        const baseUrl = await ConfigService().getConfig(keys.ePharmaCommonService);
        const cityUrl = await ConfigService().getConfig(keys.EndpointCommonCity);

        const gridParams = {
            page: 1,
            itemsPerPage: 5000,
            filter: [
                {
                    property: "stateId",
                    operator: "=",
                    value: stateId
                }
            ],
            sorter: [{PropertyName: "name", direction: "asc"}]
        };

        const response = await ePharmaServices(baseUrl).get(`${cityUrl}?gridParams=${JSON.stringify(gridParams)}`);

        setCities(response.data.data);
        setLoadingCities(false);
    }

    const getNeighborhoods = async (cityId: number, benefitId: number) =>
    {
        setLoadingNeighborhoods(true);

        const baseUrl = await ConfigService().getConfig(keys.ePharmaChainService);
        const neighborhoodUrl = await ConfigService().getConfig(keys.EndpointChainNeighborhood);

        const gridParams = {
            page: 1,
            itemsPerPage: 1000,
            filter: [],
            sorter: [{PropertyName: "name", direction: "asc"}]
        };

        const url = neighborhoodUrl.replace("{benefitId}", benefitId)
                                   .replace("{cityId}", cityId.toString());

        const response = await ePharmaServices(baseUrl).get(`${url}?Page=${gridParams.page}&ItemsPerPage=${gridParams.itemsPerPage}`);

        setNeighborhoods(response.data.data);
        setLoadingNeighborhoods(false);
    }

    const getStores = async (cityId: number, neighborhoodName: string, benefitId: number) =>
    {
        const baseUrl = await ConfigService().getConfig(keys.ePharmaChainService);
        const storeUrl = await ConfigService().getConfig(keys.EndpointChainStore);


        const gridParams = {
            page: 1,
            itemsPerPage: 1000,
            filter: [],
            sorter: [{PropertyName: "tradeName", direction: "asc"}]
        };

        const url = storeUrl.replace("{benefitId}", benefitId)
                            .replace("{cityId}", cityId.toString())
                            .replace("{neighborhood}", neighborhoodName);

        const response = await ePharmaServices(baseUrl).get(`${url}\?Page=1&gridParams=${JSON.stringify(gridParams)}`);

        return response.data.data || [];
    }


    return {
        states, getState,
        cities, getCities,
        neighborhoods, getNeighborhoods,
        loadingStates, loadingCities,
        loadingNeighborhoods, getStores, 
       
    };
}